import script from "./FundOptionsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FundOptionsForm.vue?vue&type=script&setup=true&lang=js"

import "./FundOptionsForm.vue?vue&type=style&index=0&id=4a27682c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a27682c"]])

export default __exports__